
const Swal = require('sweetalert2')

export const displayCurrency = (v, precision = 2) => {
  let amount = v;
  if (!amount) return `$0.00`;
  if (typeof amount === "string") {
    let match = amount.replace(/[^0-9]+/g, "").match(/\d+/);
    amount = match ? match[0] : 0;
  }
  amount = amount / 100;

  if (precision < 2) {
    let delta = 10**(2-precision);
    amount = Math.round(amount / delta) * delta;
  }
  
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: precision }).format(amount);
}

export const displayNumber = (v) => {
  if (!v) return "0"
  return new Intl.NumberFormat('en-US').format(v)
}

// toast notification in top right corner using swal
export const toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

export const clipboardCopy = (text) => {
  navigator.clipboard.writeText(text).then(function() {
    toast.fire({
      icon: 'success',
      title: 'Copied to clipboard',
      timer: 1000
    })
  }, function(err) {
    toast.fire({
      icon: 'error',
      title: 'Failed to copy'
    })
  });
}

export const titleCase = (str) => {
  return str.toLowerCase().replaceAll("_",' ').replaceAll('  ',' ').split(' ').map(function(word) {
    return word.replace(word[0], word[0].toUpperCase());
  }).join(' ');
  // key.replace(/_/g, " ")
  //       .replace(/\b\w/g, (char) => char.toUpperCase());
}


import { faLog } from '@/firebase'
import {auth} from '@/firebase'
export const anaLog = async (event, params) => {
  if (auth.currentUser) return
  

  let analyticsSessionId = getCookie('SelfgensAnalytics')  
  params = params || {}
  params.sessionId = analyticsSessionId
  // milliseconds since epoch
  params.timestamp = new Date().getTime()
  // human readable timestamp with timezone
  params.humanTimestamp = new Date().toString()
  // console.log('logEvent', event, params)
  faLog(event, params)
}

export function setCookie(key, value) {
  var cookieString = key + "=" + value + "; path=/";
  document.cookie = cookieString;
}


export function getCookie(name) {
  var cookieName = name + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(';');

  for (var i = 0; i < cookieArray.length; i++) {
    var cookie = cookieArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }

  return null;
}

export function unsubAll(subs) {
  subs.forEach(sub => {
    if (sub && typeof sub === "function"){
      sub();
    }else if(sub && typeof sub === "object"){
      sub.unsubscribe();
    }else{
      alert("Unknown sub type", sub);
    }
  })
}

export function displayPhoneNumber(phone) {
  if (!phone) return ""
  return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}